import { Platform } from 'react-native';
import NativeSignatureCanvas from './SignatureCanvas.native';
import WebSignatureCanvas from './SignatureCanvas.web';

// Explicit platform pick (mirrors components/SignaturePad/index.tsx) since this
// project's tsconfig has no `moduleSuffixes`, so a bare `./SignatureCanvas` import
// would otherwise fail to resolve the `.native`/`.web` files for type-checking.
const SignatureCanvasImpl = Platform.OS === 'web' ? WebSignatureCanvas : NativeSignatureCanvas;

export default SignatureCanvasImpl;
